import React, { useState, useEffect } from 'react';
import { getLivePurchases } from '../utils/api';

const LivePurchasePopup = () => {
  const [purchases, setPurchases] = useState([]);
  const [current, setCurrent] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    getLivePurchases().then(d => setPurchases(d.purchases || [])).catch(() => {});
    const interval = setInterval(() => {
      getLivePurchases().then(d => setPurchases(d.purchases || [])).catch(() => {});
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (purchases.length === 0) return;
    let idx = 0;
    const show = () => {
      setCurrent(purchases[idx % purchases.length]);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
      idx++;
    };
    const timeout = setTimeout(show, 5000);
    const interval = setInterval(show, 15000);
    return () => { clearTimeout(timeout); clearInterval(interval); };
  }, [purchases]);

  if (!current || !visible) return null;

  const timeAgo = (ts) => {
    const diff = Math.floor((Date.now() - ts) / 1000);
    if (diff < 60) return 'just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  };

  return (
    <div className={`live-purchase-popup ${visible ? 'show' : ''}`}>
      <div className="live-purchase-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
      </div>
      <div className="live-purchase-text">
        <strong>{current.name}</strong> just bought <strong>{current.quantity}x</strong> boosts
        <span className="live-purchase-time">{timeAgo(current.time)}</span>
      </div>
    </div>
  );
};

export default LivePurchasePopup;
